import type { IShopBoard, IShopInventoryTotal, IVisitShopItem } from './index'
import { QueueStatusEnum } from '../../AppConstant'
import { applyCurrentVisitShopPin } from '../../utils/applyCurrentVisitShopPin'
import type { RootState } from '../store'

/** Pin while the visit session is open; cleared after Stop when everything is delivered. */
export function shouldPinCurrentVisitShop(state: RootState): boolean {
  const currentVisit = state.lobbyPortal.currentVisit
  const sessionStatus = state.currentPatientPortal.sessionStatus
  const visitItems = state.shop.visitItems

  if (!currentVisit?.visitId || visitItems.length === 0) return false
  if (sessionStatus === QueueStatusEnum.COMPLETED) return false

  return true
}

export function allVisitShopItemsDelivered(items: IVisitShopItem[]): boolean {
  return items.length > 0 && items.every((item) => item.delivered)
}

/** Shop pickup board with active-visit pin (delivered items stay until Stop). */
export function selectShopBoardForDisplay(state: RootState): IShopBoard {
  const board = state.shop.board

  if (!shouldPinCurrentVisitShop(state)) {
    return board
  }

  const currentVisit = state.lobbyPortal.currentVisit
  const visitItems = state.shop.visitItems
  const currentPatient = state.currentPatientPortal.currentPatient

  const patientId = currentVisit?.visit?.patientId ?? currentPatient?.patient?.id
  const user = currentPatient?.patient?.user ?? currentVisit?.visit?.patient?.user

  return applyCurrentVisitShopPin(board, {
    pinActive: true,
    patientId,
    firstname: user?.firstname,
    lastname: user?.lastname,
    profilePic: user?.profilePic,
    visitItems,
  })
}

/** Full studio stock for the Inventory column (always, regardless of orders). */
export function selectShopInventoryForDisplay(state: RootState): IShopInventoryTotal[] {
  return state.shop.board.studioInventory ?? []
}

export const selectStudioInventory = (state: RootState): IShopInventoryTotal[] => state.shop.board.studioInventory ?? []
